/* MagicPoster native localisation. No external app or GeoIP service. */
(() => {
  'use strict';
  const config = document.querySelector('[data-mp-localization]');
  const form = document.getElementById('MagicPosterLanguage');
  if (!config || !form || config.dataset.pageType === '404') return;
  const current = config.dataset.language;
  const available = [...form.querySelectorAll('button[name="language_code"]')].map(b => b.value);
  const storageKey = 'magicposter-language-v1';
  const sessionKey = 'magicposter-country-checked-v1';
  let submitted = false;
  const getStored = (storage, key) => { try { return window[storage].getItem(key); } catch (_) { return null; } };
  const setStored = (storage, key, value) => { try { window[storage].setItem(key, value); } catch (_) {} };
  const url = new URL(window.location.href);
  const redirected = url.searchParams.get('mp_lang_redirect') === '1';
  if (redirected) {
    url.searchParams.delete('mp_lang_redirect');
    window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
    setStored('sessionStorage', sessionKey, '1');
  }
  function returnTo(automatic) {
    const target = new URL(window.location.href);
    if (automatic) target.searchParams.set('mp_lang_redirect', '1');
    let input = form.querySelector('[name="return_to"]');
    if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = 'return_to'; form.appendChild(input); }
    input.value = target.pathname + target.search + target.hash;
  }
  function remember(language) {
    setStored('localStorage', storageKey, language);
    document.cookie = `mp_language=${encodeURIComponent(language)}; Path=/; Max-Age=31536000; SameSite=Lax; Secure`;
    setStored('sessionStorage', sessionKey, '1');
  }
  form.addEventListener('submit', event => {
    const language = event.submitter && event.submitter.value;
    if (!available.includes(language)) return;
    submitted = true;
    remember(language);
    returnTo(false);
  });
  function switchLanguage(language) {
    if (submitted || !available.includes(language) || current === language) return;
    submitted = true;
    returnTo(true);
    const input = document.createElement('input');
    input.type = 'hidden'; input.name = 'language_code'; input.value = language;
    form.appendChild(input);
    HTMLFormElement.prototype.submit.call(form);
  }
  const cookiePreference = document.cookie.split('; ').find(x => x.startsWith('mp_language='));
  const preference = getStored('localStorage', storageKey) || (cookiePreference ? cookiePreference.split('=')[1] : null);
  // Never change previews, the theme editor, bots, or an explicit language landing URL.
  if (window.Shopify?.designMode || window.Shopify?.theme?.role === 'unpublished' || window.Shopify?.theme?.role === 'development' || url.searchParams.has('preview_theme_id') || /bot|crawler|spider|lighthouse/i.test(navigator.userAgent)) return;
  if (redirected) return;
  if (available.includes(preference)) { switchLanguage(preference); return; }
  if (getStored('sessionStorage', sessionKey)) return;
  if (/^\/(en|fr|it|es|uk)(?:\/|$)/.test(url.pathname)) {
    setStored('sessionStorage', sessionKey, '1'); return;
  }
  const controller = new AbortController();
  const timeout = window.setTimeout(() => controller.abort(), 4000);
  const root = window.Shopify?.routes?.root || '/';
  fetch(root + 'browsing_context_suggestions.json?country[enabled]=true&language[enabled]=false', {
    credentials: 'same-origin', signal: controller.signal, headers: { Accept: 'application/json' }
  }).then(response => {
    if (!response.ok) throw new Error('Location unavailable');
    return response.json();
  }).then(data => {
    const country = data?.detected_values?.country?.handle;
    if (typeof country !== 'string' || !/^[A-Z]{2}$/.test(country)) return;
    setStored('sessionStorage', sessionKey, '1');
    switchLanguage(['DE', 'AT', 'CH'].includes(country) ? 'de' : 'en');
  }).catch(() => { /* Keep the current language if location lookup is unavailable. */ })
    .finally(() => window.clearTimeout(timeout));
})();
